export default "__VITE_ASSET__rx2GYRfv__"